import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientPayersActions } from '../../actions/constant';
import patientService from '../../../services/apiServices/patientService';

const {
  VALIDATE_MDS_PAYER_REQUEST,
  VALIDATE_MDS_PAYER_SUCCESS,
  VALIDATE_MDS_PAYER_FAILURE,
  VALIDATE_MDS_PAYER_LOADING,
} = PatientPayersActions;

function* validateMdsPayer(action: any): SagaReturnType<any> {
  try {
    yield put({ type: VALIDATE_MDS_PAYER_LOADING });
    const response = yield call(patientService.validateMdsPayer, action.payload);
    if (response?.status === 200) {
      yield put({ type: VALIDATE_MDS_PAYER_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: VALIDATE_MDS_PAYER_FAILURE, payload: error });
  }
}

function* validateMdsPayerSaga() {
  yield takeLatest(VALIDATE_MDS_PAYER_REQUEST, validateMdsPayer);
}

export default validateMdsPayerSaga;
